"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNode = void 0;
let cachedIsNode;
let called = false;
const detect = new Function('try {return this===global;}catch(e){return false;}'); //eslint-disable-line no-new-func
function isNode() {
    if (called) {
        return cachedIsNode;
    }
    cachedIsNode = detect();
    called = true;
    return cachedIsNode;
}
exports.isNode = isNode;
